import { Component, Inject, OnInit } from "@angular/core";
import { CampaignBuilderService } from "@shared/services/campaign-builder.service";
import { CampaignViewModel, Universe } from "../../../../../../../shared";
import { UniversesService } from "@shared/services/universes.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "radr-profile-details-modal",
  templateUrl: "./profile-details-modal.component.html",
  styleUrls: ["./profile-details-modal.component.scss"]
})
export class ProfileDetailsModalComponent implements OnInit {
  public selectedSubscriberHouseholds: Universe[] = [];
  public selectedNonSubscriberHouseholds: Universe[] = [];
  selectedSubscriberHouseholdsTarget: number = 0;
  selectedSubscriberHouseholdsControl: number = 0;
  allHouseHoldsTarget: number = 0;
  allHouseHoldsControl: number = 0;
  constructor(
    public campaignBuilderService: CampaignBuilderService,
    public universeService: UniversesService,
    private dialogRef: MatDialogRef<ProfileDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public priority: number
  ) {}
  get campaign(): CampaignViewModel {
    return this.campaignBuilderService.getSelectedItem();
  }
  ngOnInit(): void {
    this.selectedSubscriberHouseholds = this.universeService.getSubscriberUniverses().filter(universe => {
      if (this.campaign.selectedUniverses.has(universe.name)) {
        this.addAllCounts(universe);
        return this.campaign.selectedUniverses.has(universe.name);
      }
    });
    this.selectedSubscriberHouseholdsTarget = this.allHouseHoldsTarget ?? 0;
    this.selectedSubscriberHouseholdsControl = this.allHouseHoldsControl ?? 0;
    this.selectedNonSubscriberHouseholds = this.universeService.getNonSubscriberUniverses().filter(universe => {
      if (this.campaign.selectedUniverses.has(universe.name)) {
        this.addAllCounts(universe);
        return this.campaign.selectedUniverses.has(universe.name);
      }
    });
  }
  addAllCounts(universe: Universe) {
    this.allHouseHoldsControl += this.campaignBuilderService.getProfileControlTotalUniverseCount(
      this.priority,
      universe.name
    );
    this.allHouseHoldsTarget += this.campaignBuilderService.getProfileTargetTotalUniverseCount(
      this.priority,
      universe.name
    );
  }
  close() {
    this.dialogRef.close();
  }
}
